document.addEventListener('DOMContentLoaded', function() {
  $('.fil-text table')
    .removeClass('stack')
    .wrap('<div class="table-scroll">');
});
